var _path, _path2, _circle, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMatches(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.41994 19.2634L2.51764 8.43185C2.23175 7.36492 2.86492 6.26825 3.93185 5.98236L13.1306 3.51757C14.1975 3.23169 15.2942 3.86485 15.5801 4.93179L18.4824 15.7633C18.7682 16.8302 18.1351 17.9269 17.0681 18.2128L7.86943 20.6776C6.80249 20.9635 5.70582 20.3303 5.41994 19.2634Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4482 4.57935L19.4108 5.6411C20.4777 5.92698 21.1109 7.02366 20.825 8.09059L18.4377 16.9999",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.84375,
    cy: 9.64842,
    r: 1.6904,
    transform: "rotate(-15 9.84375 9.64842)",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.32814 17.0547L8.18951 16.5373C7.90363 15.4704 8.53679 14.3737 9.60373 14.0878L12.2712 13.3731C13.3382 13.0872 14.4348 13.7204 14.7207 14.7873L14.8593 15.3046",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatches);
export default __webpack_public_path__ + "static/media/matches.e739aec2f93fbfdc2edede94ff5fd901.svg";
export { ForwardRef as ReactComponent };